module.exports = __webpack_public_path__ + "img/wireless-red-quarter.952877cf.jpg";